<template>
  <section id="header-target" class="section-base form-base">
    <template v-if="getResendStLoaded">
      <AddStatementHeader
        :title="RouteText.RESEND_TO_FSSP"
        :steps-count="RESEND_TO_FSSP_STEPS_COUNT"
        :current-step="2"
      />
      <v-row>
        <v-col>
          <v-textarea
            v-model="$v.reasonSend.$model"
            :errorMessages="getValidationErrorText($v.reasonSend)"
            outlined
            label="Причины повторной отправки"
          />
        </v-col>
      </v-row>

      <div class="form-base__footer pt-10">
        <div class="button-box justify-space-between">
          <v-btn
            depressed
            color="primary"
            class="button-base"
            :loading="loading"
            @click="prevBtnClickHandler"
            >Назад
          </v-btn>

          <v-btn
            depressed
            color="primary"
            class="button-base"
            :loading="loading"
            @click="sendPackage"
            >Подписать и отправить
          </v-btn>
        </div>
      </div>
      <SignatureComponent />
    </template>
    <SkeletonLoader v-if="getResendStLoading" />
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

import SignatureComponent from '@/components/base/SignatureComponent';
import { ServicesModule } from '@/store/modules/services';
import { getValidationErrorText } from '@/utils/validate';
import { RouteName, RouteText } from '@/router';
import { RecendStatementModule } from '@/store/modules/alternativeServices/recendStatement';
import SkeletonLoader from '@/components/base/SkeletonLoader';
import AddStatementHeader from '@/views/alternativeServices/AddStatementHeader';
import { RESEND_TO_FSSP_STEPS_COUNT } from '@/constants';
import { BreadCrumbsModule } from '@/store/modules/breadCrumbs';
import { getResendToFsspBreadcrumbs } from '@/utils/common';

export default {
  name: 'ResendToFsspSign',
  props: {
    altStatementId: {
      type: String,
      required: true,
    },
  },
  components: {
    SignatureComponent,
    SkeletonLoader,
    AddStatementHeader,
  },
  data() {
    return {
      RouteText,
      RESEND_TO_FSSP_STEPS_COUNT,
      getValidationErrorText,
      reasonSend: '',
    };
  },
  async created() {
    await RecendStatementModule.getAddStatementById(this.altStatementId);

    BreadCrumbsModule.SET(
      getResendToFsspBreadcrumbs(this.addStatement.originalStatementId)
    );
  },
  computed: {
    loading() {
      return (
        RecendStatementModule.save.loading ||
        RecendStatementModule.statementXmlBase64.loading ||
        RecendStatementModule.sendPackageState.loading
      );
    },

    addStatement() {
      return RecendStatementModule.addStatement.entity;
    },

    getResendStLoading() {
      return RecendStatementModule.addStatement.loading;
    },

    getResendStLoaded() {
      return RecendStatementModule.addStatement.loaded;
    },
  },
  validations() {
    return {
      reasonSend: {
        required,
      },
    };
  },
  methods: {
    async saveReason() {
      await RecendStatementModule.save({
        statementId: this.addStatement.id,
        reasonSend: this.reasonSend,
      });
    },

    async scrollToTop() {
      await this.$vuetify.goTo('#header-target', { duration: 200 });
    },

    async sendPackage() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        await this.scrollToTop();
        return;
      }

      try {
        await this.saveReason();
        await RecendStatementModule.getStatementXmlBase64(this.addStatement.id);

        const runSignProps = [
          { xmlSigBase64: RecendStatementModule.statementXmlBase64.entity },
          this.getDataUserCertificate(this.addStatement.applicant),
        ];

        // подписываем XmlBase64 и получаем подпись в Base64
        const signs = await ServicesModule.runSign(...runSignProps);

        await RecendStatementModule.sendPackage({
          addStatementId: this.addStatement.id,
          xmlSigBase64: signs.xmlSigBase64[0],
        });
        await this.$router.replace({
          name: RouteName.STATEMENT_DETAIL,
          params: {
            id: this.addStatement.originalStatementId,
          },
        });
      } catch (error) {
        await this.scrollToTop();
      }
    },

    getDataUserCertificate(applicant) {
      const subject = { ...applicant };
      let trusteeInfo = applicant?.person?.trusteeInfo
        ? applicant.person.trusteeInfo
        : applicant?.organization?.trusteeInfo
        ? applicant.organization.trusteeInfo
        : applicant?.foreignOrganization?.trusteeInfo
        ? applicant.foreignOrganization.trusteeInfo
        : null;
      if (trusteeInfo) {
        subject.trustee = trusteeInfo;
      }

      return subject;
    },

    prevBtnClickHandler() {
      this.$router.push({
        name: RouteName.RESEND_TO_FSSP_APPLICANT,
        params: {
          altStatementId: this.altStatementId,
        },
      });
    },
  },
};
</script>
